import styled from 'styled-components'

export const FormBoxContainer = styled.div`
  width: 65%;
  margin: 2rem;
  padding: 2rem;
  font-size: 16px;
  box-shadow: 0px 0px 20px 3px rgba(120, 121, 241, 0.2);
  border-radius: 5px;

  h1 {
    font-weight: 600;
    font-size: 24px;
    color: var(--dark);
  }

  h2 {
    font-weight: 400;
    font-size: 14px;
    color: var(--grey3);
    margin-top: 0.25rem;
  }

  button {
    margin-bottom: 2rem;
    width: 100%;
    max-width: 100%;
  }

  .title {
    margin-bottom: 2rem;
  }

  .account {
    border-top: 1px solid var(--grey4);
    padding-top: 1.5rem;
  }

  .account > a {
    color: var(--hover);
    font-weight: 500;
    margin-left: 0.5rem;
  }

  @media only screen and (max-width: 1400px) {
    //SMALL LAPTOPS
    width: 70%;
  }

  @media only screen and (max-width: 1050px) {
    //TABLET
    width: 80%;
  }

  @media only screen and (max-width: 1023px) {
    //MOBILE
    min-width: 60%;
    width: auto;
    margin: 1rem;

    :has(#finalize) {
      height: 100%;
    }

    h1 {
      font-size: 20px;
    }

    h2 {
      margin-top: 1rem;
    }

    input,
    .flexbox > label {
      font-size: 14px;
    }

    input[type='checkbox'] {
      width: 25px;
    }
  }
`
